module.exports = __webpack_public_path__ + "img/info_inverted.81b986cc.svg";